import React from 'react';
import {Helmet} from 'react-helmet';
import { store } from '../../../store';

import Tasknav from '../Tasknav'

import Save from '../Save'

import AboutSection from '../Sections/About/AboutSection'

import Profile from '../Sections/Profile/Profile'

import CustomizationPanel from '../Sections/Customization/CustomizationPanel'

import Controller from '../Sections/Customization/Controller'

import LinksFunction from '../Sections/SocialLinks/LinksFunction'
import LinksSection from '../Sections/SocialLinks/LinksSection'

import ImageUploadFunction from '../Sections/Images/ImageUploadFunction'
import {ProPic, CoverImageURL} from '../Sections/Images/ImageSection'

import Menu from '../../Navigation/Menu'

const First = ({onUser, onEdit, onOpen, onRouteChange, onCustomization, onSelectToolbar, onHighlight, onWebsiteBio, onWebsitename, onMenu, highlight, menu, handleOffClick, onClickInside, onClickOutside, onController, controller, profile_name, profile_bio, about, icons, background}) => {
const keypress = (e) => {
if (e.keyCode === 83 && e.shiftKey && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey))
	onHighlight('save')
}
  return ( 
<div id="scroll" className="editSection" onKeyUp={keypress}>          
<Helmet>
<meta name="viewport" content="width=device-width,initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Coiny:400,700,700i|Dancing+Script:400,700,700i|Indie+Flower:400,700,700i|Lato:400,700,700i|Lobster+Two|Merriweather:400,700,700i|Open+Sans:400,700,700i|Pacifico:400,700,700i|Righteous:400,700,700i|Shadows+Into+Light+Two|Lora:400,700|Vibur:400,700,700i|Oswald:400,700|Roboto+Mono:400,700|Roboto:400,700,900|Abel" rel="stylesheet" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<style type="text/css">{`
@keyframes fadeIn {
0% {
opacity: 0;
}
100% {
opacity: 1;
}
}
body{
animation: .5s ease-in-out 0s 1 fadeIn;
margin:0;
padding: 0;
max-width:100vw;
}
.wrap {
max-width:100vw !important;
margin:0;
padding: 0;
overflow:hidden;
}

.about {
padding: 1em;
position:relative;
width:80%;
z-index:1;
text-align:center;
font-family: ${about.font};
color:${about.color};
font-size:${about.size}px;
}
.paragraph,
p {
font-family: ${about.font};
color:${about.color};
margin-bottom:1em;
font-size:${about.size}px;
line-height:1.8;
}
p a {
text-decoration:underline;
color:${about.color};
}
p a:hover {
text-decoration:underline;
color:${about.color};
}
.profile-card {
animation: 1s ease-in-out 0s 1 fadeIn;
display: flex;
flex-direction:column;
align-items: center;
justify-content: center;
padding:0;
margin:0;
min-height:100vh;
}

.profile {
padding: 1.2em;
display: flex;
justify-content:center;
align-items: center;
align-content:flex-start;
margin:0 auto;
}
.profile_pic {
min-width:100px;
width: 150px;
height: 150px;
margin:0 1.2em;
border-radius: 100px;
overflow:hidden;
}
.dp {
width: 100%;
height: 100%;
object-fit: cover;
transition:.25s;
}
.profile_name {
font-family:${profile_name.font};
font-weight: 900;
text-transform: capitalize;
font-size:${profile_name.size}px;
display: block;
color:${profile_name.color};
}
.profile_desc {
font-family:${profile_bio.font};
color:${profile_bio.color};
font-size:${profile_bio.size}px;
}
.socialicon,
.socialicon:hover {
color: ${icons.color};
font-size: 22px;
margin:0.2em .2em 0em 0em;
transition: .25s;
text-decoration:none;
}
.bg-cover {
max-width:100%;
max-height:40%;
background:${background.color};
overflow:hidden;
}
.img_cover {
width: 100%;
max-height: 40vh;
object-fit: cover;
transition:.25s;
opacity: ${background.opacity};
}
.main {	
background: ${background.color} !important;
}

@media only screen and (max-width : 1200px) {
body {
	overflow-y:auto;
}
.main {
flex:1;
flex-flow: column;
}
.flex-right {
flex:1;
}
.flex-left {
flex:1;
}
}

@media only screen and (min-width : 1200px) {
.main {
display: flex;  
flex-flow: row;
flex:3;
}
.flex-right {
flex:1;
height: 100vh !important;
overflow-y:auto !important;
overflow-x:hidden;
}
.flex-left {
flex:2;
}
.bg-cover {
flex:4;
overflow:hidden;
min-height: 100vh !important;
}
.bg_null {
	width:68vw;
}
.bg_null_dp {
	width:70vw;
}
.img_cover {
min-height: 100vh !important;
object-fit: cover;
transition:.25s;
}
.profile-card {
animation: 1s ease-in-out 0s 1 fadeIn;
}
}
`}</style>
</Helmet>
{(store.getState().activities.edit)         
? <div className="toptoolbar">
	<Tasknav
	onRouteChange={onRouteChange}
	onEdit={onEdit}
	onOpen={onOpen}
	onHighlight={onHighlight}
	highlight={highlight}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside}
	/><span className="navmargin"><br /><br /><br /></span></div>
: null
}
<div className="wrap">
<div>
<div className="main">
<div className="flex-left">
{(store.getState().activities.edit)  
? (
<div className="bg-cover">
<span onClick={
(open,select)=>
{
onOpen('cover')
}}  className="img_edit_cover"><i class="fa fa-camera img_edit_cover_icon" aria-hidden="true"></i> Upload</span>
<img alt="img_cover select" src={CoverImageURL()} className="img_cover"/>
</div>)
: (
<div className="bg-cover">
{
	CoverImageURL() !== null
	? <img alt="img_cover" src={CoverImageURL()} className="img_cover" />
	: 
		CoverImageURL() !== null
		? <div className="bg_null" />
		: <div className="bg_null_dp" />
}
</div>)
}
</div>
<div className={
	store.getState().activities.edit
	? 'flex-right select_col'
	: 'flex-right'
}>
<div className="profile-card">
<div className="profile">
{(store.getState().activities.edit)  
? 	<div className="profile_pic">
	<div className="dp select" onClick={(open)=>
	{
	onOpen('propic')
	}}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="dp"/></div>
	</div>
: ProPic() !== null
  ? <div className="profile_pic">
    <img alt="dp" src={ProPic()} className="dp"/>
    </div>
  : null
}
<div className={
	store.getState().activities.edit
	? 'select_col'
	: ''
}>
<Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
<Controller
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
/>
<div className="social_media">
<LinksFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>        
<LinksSection onOpen={onOpen}/>
{(store.getState().activities.edit) 
? <span class="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
: null
}
</div>
</div>
</div>
<div className={
	store.getState().activities.edit
	? 'about select_col'
	: 'about'
}>
<AboutSection/>
</div>
{highlight === 'save'     
? <Save onHighlight={onHighlight} />
: null
}
{(!store.getState().activities.edit)         
?<span className="editbtn" onClick={(edit,open)=>{
onEdit(true)
onOpen(null)
onHighlight(null)
}}>Edit</span>
:<span />
}
{store.getState().activities.open === 'menu'
? <Menu
	onOpen={onOpen}
	onRouteChange={onRouteChange} 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
: null
}
<CustomizationPanel 
	onEdit={onEdit}
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
	onCustomization={onCustomization}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside} />
<ImageUploadFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
</div>
</div>
</div>
</div>
</div>
</div>
  )
}

export default First